import { Progress } from "antd"
import React, { useEffect, useState } from "react"

import { addZero } from "@/utils/utils"

import "./style.less"

const formatTime = (seconds: number) => {
    let h = (seconds) / 3600 % 24 >> 0,
        m = (seconds) / 60 % 60 >> 0,
        s = (seconds) % 60

    return {
        h: addZero(h),
        m: addZero(m),
        s: addZero(s)
    }
}

const Day: React.FC<{
    create: number
    end: number
    endCallback(): void,
}> = ({ end, create, endCallback }) => {
    const initCountDown = end - create;
    const countDown = end - (Date.now() / 1000 >> 0)
    const initPercent = (countDown / initCountDown) * 100
    const initFormattedTime = formatTime(countDown)
    const [percent, setPercent] = useState(initPercent)
    const [{ h, m, s }, setTime] = useState<{ h: string, m: string, s: string }>(initFormattedTime)

    useEffect(() => {
        let interval: ReturnType<typeof setInterval>

        if (end && initCountDown) {
            interval = setInterval(() => {
                const countDown = end - (Date.now() / 1000 >> 0)
                const formattedTime = formatTime(countDown)
                const { h, m, s } = formattedTime
                setTime(formattedTime)
                setPercent((countDown / initCountDown) * 100)
                if (Math.max(Number(h), Number(m), Number(s)) === 0) {
                    clearInterval(interval)
                    endCallback()
                }
            }, 1_000)
        }
        return () => {
            clearInterval(interval)
        }
    }, [end, initCountDown])

    return (
        <React.Fragment>
            <Progress className="timer-progress" size={38} showInfo={false} type="circle" percent={percent} />
            <div className="timer-content">
                <div className="timer-title">Expiration time</div>
                <span className="timer-countDown">{h}:{m}:{s}</span>
            </div>
        </React.Fragment>
    )
}

export default Day